/*
 *   Copyright (c) 2020 BuserNet Consulting LLC
 *   All rights reserved.
 */
import updateRequiredService from './services/updateRequired.service';
import EventConst from './constants/event.constant';
import Emitter from './bus';
import { navigateToLastStateOrDefault } from './services/navigateToLastStateOrDefault';
import { loadDeviceAndApplicationSettings } from './services/loadDeviceAndApplicationSettings';

const initApplication = () => {
  loadDeviceAndApplicationSettings();
  navigateToLastStateOrDefault();
  // Reload device specific setting after otu
  Emitter.emit(EventConst.favorite.loadFavorite);
  updateRequiredService.checkIfUpdateIsRequired();
};
export { initApplication };
